import { useEffect, useState } from 'react';
// mantine
import { Rating } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
// utils
import { TSessionsData } from '@newo/api/gateway';
import { FIELD_CHANGE_DEBOUNCE_DELAY } from '@/pages/Sessions/Sessions.utils.ts';

interface PenaltyInputProps {
    sessionId: string;
    value: number | null;
    onSave: (sessionId: string, data: TSessionsData) => void;
}

const SCALE_MULTIPLIER = 5;

const PenaltyInput = ({ value, sessionId, onSave }: PenaltyInputProps) => {
    const [penalty, setPenalty] = useState(
        value ? value * SCALE_MULTIPLIER : 0
    );
    const [debounced] = useDebouncedValue(
        penalty / SCALE_MULTIPLIER,
        FIELD_CHANGE_DEBOUNCE_DELAY
    );

    useEffect(() => {
        if (debounced && debounced !== value) {
            onSave(sessionId, {
                conversation_penalty: debounced
            });
        }
    }, [debounced, onSave, sessionId, value]);

    return <Rating fractions={1} value={penalty} onChange={setPenalty} />;
};

export default PenaltyInput;
